import { Filter } from "@/common/model/Filter";
import { Nullable } from "@/general/custom-types/CustomTypes";
import { notNullOrUndefinedOrBlank } from "@/utility/functions";

export class CustomerFilter extends Filter {
  name: Nullable<string>;
  country: Nullable<string>;

  constructor(name?: Nullable<string>, country?: Nullable<string>) {
    super("customer-filter");
    this.name = name;
    this.country = country;
  }

  clear(): void {}

  toQueryParam(): string {
    let query: string = "";
    if (notNullOrUndefinedOrBlank(this.name)) {
      query = query + "&name=" + this.name;
    }
    return query;
  }
}
